import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
export function LeadsTable() {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  // Mock data for leads (at least 12)
  const mockLeads = [{
    id: '1',
    name: 'John Doe',
    email: 'john.doe@example.com',
    phone: '(555) 123-4567',
    status: 'New'
  }, {
    id: '2',
    name: 'Jane Smith',
    email: 'jane.smith@example.com',
    phone: '(555) 234-5678',
    status: 'Contacted'
  }, {
    id: '3',
    name: 'Michael Johnson',
    email: 'michael.johnson@example.com',
    phone: '(555) 345-6789',
    status: 'Qualified'
  }, {
    id: '4',
    name: 'Emily Davis',
    email: 'emily.davis@example.com',
    phone: '(555) 456-7890',
    status: 'New'
  }, {
    id: '5',
    name: 'Robert Wilson',
    email: 'robert.wilson@example.com',
    phone: '(555) 567-8901',
    status: 'Contacted'
  }, {
    id: '6',
    name: 'Sarah Brown',
    email: 'sarah.brown@example.com',
    phone: '(555) 678-9012',
    status: 'Qualified'
  }, {
    id: '7',
    name: 'David Miller',
    email: 'david.miller@example.com',
    phone: '(555) 789-0123',
    status: 'New'
  }, {
    id: '8',
    name: 'Jennifer Taylor',
    email: 'jennifer.taylor@example.com',
    phone: '(555) 890-1234',
    status: 'Contacted'
  }, {
    id: '9',
    name: 'James Anderson',
    email: 'james.anderson@example.com',
    phone: '(555) 901-2345',
    status: 'Qualified'
  }, {
    id: '10',
    name: 'Lisa Thomas',
    email: 'lisa.thomas@example.com',
    phone: '(555) 012-3456',
    status: 'New'
  }, {
    id: '11',
    name: 'Daniel Jackson',
    email: 'daniel.jackson@example.com',
    phone: '(555) 123-4567',
    status: 'Contacted'
  }, {
    id: '12',
    name: 'Michelle White',
    email: 'michelle.white@example.com',
    phone: '(555) 234-5678',
    status: 'Qualified'
  }, {
    id: '13',
    name: 'Christopher Harris',
    email: 'christopher.harris@example.com',
    phone: '(555) 345-6789',
    status: 'New'
  }, {
    id: '14',
    name: 'Amanda Martin',
    email: 'amanda.martin@example.com',
    phone: '(555) 456-7890',
    status: 'Contacted'
  }, {
    id: '15',
    name: 'Matthew Thompson',
    email: 'matthew.thompson@example.com',
    phone: '(555) 567-8901',
    status: 'Qualified'
  }];
  // Pagination logic
  const totalPages = Math.ceil(mockLeads.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentLeads = mockLeads.slice(indexOfFirstItem, indexOfLastItem);
  // Handle page changes
  const handlePageChange = pageNumber => {
    setCurrentPage(pageNumber);
  };
  // Get status badge class
  const getStatusBadgeClass = status => {
    switch (status) {
      case 'New':
        return 'bg-green-100 text-green-800';
      case 'Contacted':
        return 'bg-blue-100 text-blue-800';
      case 'Qualified':
        return 'bg-purple-100 text-purple-800';
      default:
        return 'bg-neutral-100 text-neutral-800';
    }
  };
  return <div data-id="element-2105">
      <div className="flex justify-between items-center mb-6" data-id="element-2106">
        <h1 className="text-2xl font-bold" data-id="element-2107">Leads</h1>
        <button className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700" data-id="element-2108">
          Add New Lead
        </button>
      </div>
      <div className="bg-white rounded-lg shadow overflow-hidden" data-id="element-2109">
        <table className="min-w-full divide-y divide-neutral-200" data-id="element-2110">
          <thead className="bg-neutral-50" data-id="element-2111">
            <tr data-id="element-2112">
              <th className="px-6 py-3 text-left text-xs font-medium text-neutral-500 uppercase tracking-wider" data-id="element-2113">
                Name
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-neutral-500 uppercase tracking-wider" data-id="element-2114">
                Email
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-neutral-500 uppercase tracking-wider" data-id="element-2115">
                Phone
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-neutral-500 uppercase tracking-wider" data-id="element-2116">
                Status
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-neutral-500 uppercase tracking-wider" data-id="element-2117">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-neutral-200" data-id="element-2118">
            {currentLeads.map(lead => <tr key={lead.id} data-id="element-2119">
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-2120">
                  <div className="text-sm font-medium text-neutral-900" data-id="element-2121">
                    {lead.name}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-2122">
                  <div className="text-sm text-neutral-500" data-id="element-2123">{lead.email}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-2124">
                  <div className="text-sm text-neutral-500" data-id="element-2125">{lead.phone}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-2126">
                  <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${getStatusBadgeClass(lead.status)}`} data-id="element-2127">
                    {lead.status}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-neutral-500" data-id="element-2128">
                  <Link to={`/leads/${lead.id}`} className="text-blue-600 hover:text-blue-900" data-id="element-2129">
                    View
                  </Link>
                </td>
              </tr>)}
          </tbody>
        </table>
        {/* Pagination */}
        <div className="px-6 py-3 flex items-center justify-between border-t border-neutral-200" data-id="element-2130">
          <div className="flex-1 flex justify-between sm:hidden" data-id="element-2131">
            <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} className={`relative inline-flex items-center px-4 py-2 border border-neutral-300 text-sm font-medium rounded-md ${currentPage === 1 ? 'bg-neutral-100 text-neutral-400 cursor-not-allowed' : 'bg-white text-neutral-700 hover:bg-neutral-50'}`} data-id="element-2132">
              Previous
            </button>
            <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} className={`ml-3 relative inline-flex items-center px-4 py-2 border border-neutral-300 text-sm font-medium rounded-md ${currentPage === totalPages ? 'bg-neutral-100 text-neutral-400 cursor-not-allowed' : 'bg-white text-neutral-700 hover:bg-neutral-50'}`} data-id="element-2133">
              Next
            </button>
          </div>
          <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between" data-id="element-2134">
            <div data-id="element-2135">
              <p className="text-sm text-neutral-700" data-id="element-2136">
                Showing{' '}
                <span className="font-medium" data-id="element-2137">{indexOfFirstItem + 1}</span> to{' '}
                <span className="font-medium" data-id="element-2138">
                  {indexOfLastItem > mockLeads.length ? mockLeads.length : indexOfLastItem}
                </span>{' '}
                of <span className="font-medium" data-id="element-2139">{mockLeads.length}</span>{' '}
                results
              </p>
            </div>
            <div data-id="element-2140">
              <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination" data-id="element-2141">
                <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} className={`relative inline-flex items-center px-2 py-2 rounded-l-md border border-neutral-300 bg-white text-sm font-medium ${currentPage === 1 ? 'text-neutral-300 cursor-not-allowed' : 'text-neutral-500 hover:bg-neutral-50'}`} data-id="element-2142">
                  <span className="sr-only" data-id="element-2143">Previous</span>
                  <ChevronLeftIcon className="h-5 w-5" data-id="element-2144" />
                </button>
                {/* Page numbers */}
                {Array.from({
                length: totalPages
              }).map((_, index) => <button key={index} onClick={() => handlePageChange(index + 1)} className={`relative inline-flex items-center px-4 py-2 border text-sm font-medium ${currentPage === index + 1 ? 'z-10 bg-primary-50 border-primary-500 text-primary-600' : 'bg-white border-neutral-300 text-neutral-500 hover:bg-neutral-50'}`} data-id="element-2145">
                    {index + 1}
                  </button>)}
                <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} className={`relative inline-flex items-center px-2 py-2 rounded-r-md border border-neutral-300 bg-white text-sm font-medium ${currentPage === totalPages ? 'text-neutral-300 cursor-not-allowed' : 'text-neutral-500 hover:bg-neutral-50'}`} data-id="element-2146">
                  <span className="sr-only" data-id="element-2147">Next</span>
                  <ChevronRightIcon className="h-5 w-5" data-id="element-2148" />
                </button>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>;
}